import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "@/pages/home/page";
import Leads from "@/pages/leads/page";
import LeadDetail from "@/pages/leads/detail/page";
import Guide from "@/pages/guide/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "leads",
        element: <Leads />,
      },
      {
        path: "leads/:id",
        element: <LeadDetail />,
      },
      {
        path: "guide",
        element: <Guide />,
      },
      {
        path: "about",
        element: <About />,
      },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;